import {inject, injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";
import type {ICoupon, ICouponApiProvider} from "data/providers/api/coupon.api.provider";
import {Bindings} from "data/constants/bindings";
import {CouponType} from "data/enums";

export interface ICouponStore {
	get firstPickSubmissionCoupon(): ICoupon | undefined;

	fetch: () => Promise<void>;
}

@injectable()
export class CouponStore implements ICouponStore {
	@observable private _coupons: ICoupon[] = [];

	get firstPickSubmissionCoupon() {
		return this._coupons.find(({type}) => type === CouponType.FirstPickSubmission);
	}

	constructor(
		@inject(Bindings.CouponApiProvider) private _couponApiProvider: ICouponApiProvider
	) {
		makeAutoObservable(this);
	}

	fetch = async () => {
		const {data} = await this._couponApiProvider.get();

		this._coupons = data.success.coupons;
	};
}
